/**
 * 收入侧 Invoice 金额展示工具。
 * 数据库/接口金额单位为「厘」（1 分 = 10 厘）；页面展示换算到「分」精度并四舍五入，
 * 再按货币格式展示到 cent（2 位小数）。
 */

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  CNY: '¥',
  HKD: 'HK$',
  CAD: 'C$',
};

/** 分 → 元（number），四舍五入到分。 */
export const centsToYuan = (cents?: number | null): number => {
  if (cents == null) return 0;
  return cents / 100; // 分 → 元
};

/** 分 → 带币种符号的展示字符串，如 "$ 1,234.56"。 */
export const formatCentsAmount = (cents?: number | null, currency?: string | null): string => {
  const symbol = CURRENCY_SYMBOLS[(currency ?? 'USD').toUpperCase()] ?? currency ?? '';
  const yuan = centsToYuan(cents);
  const formatted = yuan.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol} ${formatted}`.trim();
};

/** YYYYMMDD (number) → "YYYY-MM-DD"。 */
export const formatYyyymmdd = (v?: number | null): string => {
  if (v == null) return '-';
  const s = String(v);
  if (s.length !== 8) return s;
  return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
};
